import { useCallback } from 'react';
import { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';

export function usePendingChanges<T extends FieldValues>(
  form: UseFormReturn<T>,
) {
  const { formState, getFieldState, getValues, reset } = form;

  const getFieldStatus = (field: FieldPath<T>) => ({
    hasPendingChanges: getFieldState(field, formState).isDirty,
  });
  const markChangesSaved = useCallback(
    (savedValue?: T) => reset(savedValue ?? getValues()),
    [getValues, reset],
  );
  const resetPendingChanges = useCallback(
    (savedValue: T) => reset(savedValue),
    [reset],
  );

  return {
    hasPendingChanges: formState.isDirty,
    getFieldStatus,
    markChangesSaved,
    resetPendingChanges,
  };
}
